const groups = [
    'primaries',
    'tacticals',
    'thresholds',
    'pools',
    'skills'
]

export default groups;